export class GeoPoint {
    type;
    coordinates;
    constructor(coordinates) {
        this.type = 'Point';
        this.coordinates = coordinates;
    }
}
//# sourceMappingURL=geo.js.map